import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Row, Col } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import swal from 'sweetalert';
import { showLoader, showMessage, handleHTTPError, putSystemSettings } from 'store/actions';
import { updateSystemSettings } from 'apis';
import TextBox from 'components/controls/TextBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
class EventTypes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            eventTypes: [],
            validate: false,
        };
        this.newEventTypeRef = React.createRef();
    }

    componentDidMount = () => {
        let eventTypes = this.props.systemSettings.cmtyEventTypes || [];
        if (eventTypes.length === 0) eventTypes = [''];
        this.setState({ eventTypes });
    };

    update = () => {
        this.setState({ validate: true });

        // check empty event type
        if (this.state.eventTypes.some((type) => !type)) return;

        // check duplicated even type
        let dupEventType = this.state.eventTypes.find((type, index, self) => self.indexOf(type) !== index);
        if (dupEventType)
            return this.props.showMessage({
                show: true,
                message: { type: 'warning', text: `Duplicated event type "${dupEventType}"` },
            });

        const params = {
            _id: this.props.systemSettings._id,
            cmtyEventTypes: this.state.eventTypes.sort((a, b) => (a > b ? 1 : a < b ? -1 : 0)),
        };
        this.props.showLoader(true);
        updateSystemSettings(params)
            .then((data) => {
                this.props.showLoader(false);
                this.props.putSystemSettings(data.data);
                this.props.showMessage({
                    show: true,
                    message: {
                        type: 'success',
                        text: 'Community event types has been updated.',
                    },
                });
            })
            .catch((error) => {
                this.props.showLoader(false);
                this.props.handleHTTPError(error);
            });
    };

    add = () => {
        const eventTypes = [...this.state.eventTypes, ''];
        this.setState({ validate: false, eventTypes });
        setTimeout(() => {
            this.newEventTypeRef.current.scroll({ top: this.newEventTypeRef.current.scrollHeight, behavior: 'smooth' });
        }, 300);
    };

    delete = async (index) => {
        const eventTypes = [...this.state.eventTypes];
        const ok = await swal({
            title: 'Warning',
            text: `Do you want to remove this Event Type? \n Are you sure?`,
            dangerMode: true,
            buttons: ['No', 'Yes'],
            icon: 'warning',
        });
        if (!ok) {
            return;
        }
        eventTypes.splice(index, 1);
        this.setState({ eventTypes });
    };

    render() {
        const displayEventTypes = () => {
            return this.state.eventTypes.map((type, index) => {
                return (
                    <div key={index} className="mb-3 d-flex">
                        <TextBox
                            id={`prefix${index}`}
                            name={`prefix${index}`}
                            type="text"
                            className="mr-5"
                            onBlur={() => {}}
                            validate={this.state.validate}
                            value={type || ''}
                            placeholder="Sports-Racket"
                            onChange={(name, e) => {
                                const eventTypes = [...this.state.eventTypes];
                                eventTypes[index] = name;
                                this.setState({ eventTypes });
                            }}
                            validationOption={{
                                required: true,
                                check: true,
                                showMsg: false,
                            }}
                        />
                        <div
                            className="text-secondary h1 d-flex justify-content-center align-items-end mb-2 pointer w-25"
                            onClick={() => {
                                this.delete(index);
                            }}
                        >
                            <FontAwesomeIcon icon="times" />
                        </div>
                    </div>
                );
            });
        };

        return (
            <>
                <h2 className="mb-5 font-weight-bold text-center">Community Event Types</h2>
                <div
                    style={{ maxHeight: '500px', overflowY: 'auto' }}
                    className="border py-3 pl-3 mb-4"
                    ref={this.newEventTypeRef}
                >
                    {displayEventTypes()}
                </div>
                <Row>
                    <Col md={6}>
                        <Button color="primary" className="btn btn-lg btn-block" onClick={this.add}>
                            <FontAwesomeIcon icon="plus" className="mr-3" />
                            Add New Event Type
                        </Button>
                    </Col>
                    <Col md={6}>
                        <Button color="secondary" className="btn btn-lg btn-block" onClick={this.update}>
                            <FontAwesomeIcon icon="save" className="mr-3" />
                            Save
                        </Button>
                    </Col>
                </Row>
            </>
        );
    }
}

const mapStateToProps = ({ user }) => {
    const { authUser, systemSettings } = user;
    return { authUser, systemSettings };
};

export default withRouter(
    connect(mapStateToProps, {
        showLoader,
        showMessage,
        handleHTTPError,
        putSystemSettings,
    })(EventTypes),
);
